import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Linkedin } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { DirigeantJT } from './../../../../src/assets/img/society';
import './backaltered.css';

const BackAltered = (): React.JSX.Element => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [isVisibleEllipseTop, setIsVisibleEllipseTop] = React.useState(false);
    const [isVisibleEllipseBottom, setIsVisibleEllipseBottom] = React.useState(false);
    const [isVisibleCoverCircle, setIsVisibleCoverCircle] = React.useState(false);
    const [isVisibleTopGradient, setIsVisibleTopGradient] = React.useState(false);
    const [isVisibleBottomGradient, setIsVisibleBottomGradient] = React.useState(false);
    const [isVisibleFullGradient, setIsVisibleFullGradient] = React.useState(false);
    const [isVisibleSMedia, setIsVisibleSMedia] = React.useState(false);
    const _pathname = pathname.replace(/\/$/, "").split("/")[2];
    const getBodyHeight = () => {
        const getBody = document.querySelector('#root');
        const getBAlt = document.querySelector('.b-alt span');
        if (getBody) {
            const bodyHeight = getBody.clientHeight;
            getBAlt?.setAttribute("style", `height: ${bodyHeight}px;`);
        }
    };

    useEffect(() => {
        getBodyHeight();
        setIsVisibleEllipseTop(false);
        setIsVisibleEllipseBottom(false);
        setIsVisibleCoverCircle(false);
        setIsVisibleTopGradient(false);
        setIsVisibleBottomGradient(false);
        setIsVisibleFullGradient(false);
        setIsVisibleSMedia(false);
        const society = ["societe", "company", "empresa"];
        const media = ["medias", "medios"];
        const eventsxmedias = ["a-la-une", "en-primera-plana", "headlines"];
        const contact = ["contact", "contacto"];
        const solution = ["solution", "solucion"];
        const expertise = ["expertises", "saber-hacer"];
        const legal = ["legal"];
        const cookie = ["cookie"];
         switch (true) {
             case society.includes(_pathname):
    //             setIsVisibleSMedia(true);
                 setIsVisibleCoverCircle(true);
                 setIsVisibleTopGradient(true);
                 setIsVisibleBottomGradient(true);
                 break;
             case media.includes(_pathname):
                setIsVisibleEllipseTop(true);
      //          setIsVisibleSMedia(true);
                break;
             case contact.includes(_pathname):
                setIsVisibleEllipseTop(true);
        //        setIsVisibleSMedia(true);
                 break;
             case solution.includes(_pathname):
                //  setIsVisibleEllipseTop(true);
                 setIsVisibleEllipseBottom(true);
                 break;
             case expertise.includes(_pathname): break;
             case legal.includes(_pathname): break;
             case cookie.includes(_pathname): break;
             case eventsxmedias.includes(_pathname):
                 setIsVisibleFullGradient(false);
                 break;
             default:
                 //setIsVisibleSMedia(true);
                 setIsVisibleFullGradient(true);
                 break;
         }
     }, [_pathname]);

     return (
         <span className="content-alt">
             <div className={`b-top-gradient ${!isVisibleTopGradient ? "d-none" : ""}`}>
             </div>
             <div className="b-alt-flex b-alt-center">
                <div className={`b-cover-circle ${!isVisibleCoverCircle ? "d-none" : ""}`}>
                    <img src={DirigeantJT} alt={t('Pages.Society.AltDirigeant')} />
                </div>
             </div>
             <div className={`b-bottom-gradient ${!isVisibleBottomGradient ? "d-none" : ""}`}>
             </div>
             <div className={`b-ellipse b-ellipse-top ${!isVisibleEllipseTop ? "d-none" : ""}`}>
             </div>
             <div className={`b-ellipse b-ellipse-bottom ${!isVisibleEllipseBottom ? "d-none" : ""}`}>
             </div>
             <div className={`smedia-sidebar ${!isVisibleSMedia ? "d-none" : ""}`}>
                 <div className="smedia-content">
                     <a href="https://www.linkedin.com/company/flowly1/" target="_blank" rel="noreferrer">
                         <span className="smedia-sidebar"><Linkedin size="18" /></span>
                         <span className="smedia-divider"></span>
                         <span className="smedia-text">{t("NavBar.FollowUs")}</span>
                     </a>
                 </div>
             </div>
             <div className={`b-full-gradient ${!isVisibleFullGradient ? "d-none" : ""}`}>
             </div>

         </span>
     );
};

export default BackAltered;
